import React from 'react'
import AddNewEmailTemplate from '../../../features/FieldManagement/EmailTempManagement/AddNewEmailTemplate'

const AddEmailTemplate = () => {
    return (
        <AddNewEmailTemplate />
    )
}

export default AddEmailTemplate